import { configureStore } from "@reduxjs/toolkit";
import issuerSlice from "./slices/issuer-slice";
import productSlice from "./slices/product-slice";
import customerSlice from "./slices/customer-slice";
import userSlice from "./slices/user-slice";
import countrySlice from "./slices/country-slice";
import currencySlice from "./slices/currency-slice";
import subscriptionPaymentSlice from "./slices/subscription-payment-slice";
import subscriptionPlanSlice from "./slices/subscription-plan-slice";
import enterpriseSubscriptionSlice from "./slices/enterprise-subscription-slice";
import roleSlice from "./slices/role-slice";
import rolePrivilegeSlice from "./slices/role-privilege-slice";
import apiUserSlice from "./slices/api-user-slice";
import ncdDataSlice from "./slices/ncd-data-slice";

const store = configureStore({
    reducer: { 
        issuer: issuerSlice.reducer, 
        product: productSlice.reducer,
        customer: customerSlice.reducer,
        user: userSlice.reducer,
        country: countrySlice.reducer,
        currency: currencySlice.reducer,
        subscriptionPayment: subscriptionPaymentSlice.reducer,
        subscriptionPlan: subscriptionPlanSlice.reducer,
        enterpriseSubscription: enterpriseSubscriptionSlice.reducer,
        role: roleSlice.reducer,
        rolePrivilege: rolePrivilegeSlice.reducer,
        apiUser: apiUserSlice.reducer,
        ncdData: ncdDataSlice.reducer,
    }
});

export default store;